// @flow

import React, {type Node} from 'react';
import styled from 'styled-components';

import {colors} from 'js-libs/sweetcommons/styles';

const StyledIndentedDiv = styled.div`
  border-left: 3px solid ${colors.borderGray};
  margin-left: 5px;
  padding: 0.5rem;
  margin-top: 0.25rem;

  ul {
    padding-left: 1rem;
    margin: 0 0 0 0.25rem;

    li {
      padding: 0.25rem 0;
    }
  }
`;

type Props = {
  title: string,
  children: Node,
};

export function IndentedFormGroup({title, children}: Props) {
  return (
    <div className="form-group">
      <div>{title}</div>
      <StyledIndentedDiv>{children}</StyledIndentedDiv>
    </div>
  );
}
